import { resolveData } from "@jsonforms/core";

export const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null && !Array.isArray(value);

export const isValueArray = (value: unknown): value is unknown[] =>
	Array.isArray(value);

export const dataAtPath = (data: unknown, path: string): unknown =>
	resolveData(data, path);

/** Clone form data without turning an unfilled array draft into an explicit null. */
export function cloneValue(value: unknown): unknown {
	if(isValueArray(value)) {
		return value.map(cloneValue);
	}

	if(isRecord(value)) {
		return Object.fromEntries(
			Object.entries(value)
				.map(([key, child]) => [
					key,
					cloneValue(child)
				])
		);
	}

	return value;
}
